import React, {Component} from 'react';

import Buff from '../common/buff';
import communityService from '../../services/community';
import AnimatedWrapper from '../core/animated-wrapper';

import './community.css';
import facebookGroup from '../../assets/images/facebook-group.png';
import linkedinGroup from '../../assets/images/linkedin-group.png';
import shareService from '../../services/share';
import SmartAd from '../ads/smart-ad';

class Community extends Component {
  constructor(props) {
    super(props);

    shareService.setupPage({
      title: "Community - Angular & TypeScript groups on Facebook & Linkedin",
      isTitlePrefixOn: false,
      tags: ["facebook", "linkedin", "angular", "typescript"]
    });  

    this.state = { 
      facebookMembersCount: null,
      linkedinMembersCount: null,
      isLoading: true,
      isError: false      
    };  
  }

  componentDidMount() {
    communityService.getCommunity()
      .then((groupsCounts) => {

        const newState = Object.assign({
          isLoading: false,
          isError: false
        }, groupsCounts);
          
        this.setState(newState);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });      
  }

  render() {
    return (
      <div className='regular-page community-page'>
        <div className='community-container'>
          <h3 className='page-title'>
            Community
          </h3>

          <hr className='title-separator' />

          <div>
            <p> 
              'Angular & Typescript' are a fast-growing LinkedIn & Facebook communities that we started in 2016.
            </p>
            
            <SmartAd />
            
            <p> 
              The groups focus on version releases, features of the technologies, the special combination of the Angular and TypeScript, best practices, coding standards, integration with server-side technologies and more. The content sources are varied and contain articles, videos, sample projects and pictures, so everyone can choose his best way to enjoy the content.
            </p>            
          </div>

          <div className='network-groups-container'> 
            <div className='network-group-container little-grow-animation'>
              <a href='https://www.facebook.com/groups/angular2typescript' target='_blank' title='facebook group' rel="noopener noreferrer">
                { this.state.facebookMembersCount ? <Buff text={`${this.state.facebookMembersCount} members`} /> : '' }
                  
                <div className='network-group-img-container'>
                  <img 
                    src={facebookGroup} 
                    className='network-group-img' 
                    title='facebook group' 
                    alt='facebook group' />
                </div>

                <div className='image-bottom-bar'>
                  <h3>Angular & Typescript on Facebook</h3>
                </div> 
              </a>             
            </div>

            <div className='network-group-container little-grow-animation'>
              <a href='https://www.linkedin.com/groups/7053365' target='_blank' title='linkedin group' rel="noopener noreferrer">
                { this.state.linkedinMembersCount ? <Buff text={`${this.state.linkedinMembersCount} members`} /> : '' }

                <div className='network-group-img-container'>
                    <img 
                      src={linkedinGroup} 
                      className='network-group-img' 
                      title='linkedin group' 
                      alt='linkedin group' />

                  <div className='image-bottom-bar'>
                    <h3>Angular & Typescript on Linkedin</h3>
                  </div> 
                </div>
              </a> 
            </div>
          </div> 

          <div>
            <p> 
              The groups are a home for developers, which can read about the cutting-edge technologies and stay updated in the web world. The followers can also ask questions and take an advice with the thousands of fans around the world.
            </p>
          </div>          
        </div>
      </div>
    );
  }
};

const AnimatedCommunity = AnimatedWrapper(Community);
export default AnimatedCommunity;